<template>
  <div class="land-use">
    <h2 class="land-use-title">Выбрать тип использования</h2>
    <div class="land-use-content" v-if="$apollo.queries.formattedLandUseList.loaing">
      loading ////\\\\
    </div>
    <div v-else>
      <tree-component :inputData="formattedLandUseList"/>
    </div>
    <button class="btn accent-btn tree-button" @click="acceptFilters()">Применить</button>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import TreeComponent from '../tree/TreeComponent'

const GET_TYPE_OF_USE = gql`
query landUseList {
  landUseList{
    edges{
      node{
        code
        parentCode
        text
      }
    }
  }
}
`
export default {
  components: {
    TreeComponent
  },
  data () {
    return {
      landUseList: {},
      formattedLandUseList: []
    }
  },
  apollo: {
    formattedLandUseList: {
      query: GET_TYPE_OF_USE,
      update: data => {
        let arr = data.landUseList.edges.map(item => {
          // let parentIndex = data.landUseList.edges.findIndex(_item => {
          //   return item.parentCode === _item.code
          // })

          let a = {
            id: item.node.code,
            parent: item.node.parentCode !== null ? item.node.parentCode : '#',
            text: item.node.text
          }
          // console.log(a)

          return a
        })
        return arr
      }
    }
  }
}
</script>

<style lang="scss">
.land-use {
  width: 100%;
  height: 100%;
  padding: 20px 0 80px 40px;

  &-title {
    margin-bottom: 20px;
  }
}
.tree-button {
  position: absolute;
  right: 50px;
  bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/LandUseListVue.vue